import { M8ClientBalance } from 'services/production/types';
import { ClientFinances } from 'types/state';

export const normalizeM8ClientBalance = (m8ClientBalance: M8ClientBalance) => ({
  toClientFinances(): ClientFinances {
    return {
      balanceAmount: m8ClientBalance.balance,
      incomeAmount: m8ClientBalance.incomeForClient,
      agmPartAmount: m8ClientBalance.agmPart,
      partnerPartAmount: m8ClientBalance.partnerPart,
    };
  },
});
